import { render } from "./FriendsRequest.vue?vue&type=template&id=0d930bc0&scoped=true"
import script from "./FriendsRequest.vue?vue&type=script&lang=js"
export * from "./FriendsRequest.vue?vue&type=script&lang=js"

import "./FriendsRequest.vue?vue&type=style&index=0&id=0d930bc0&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d930bc0"]])

export default __exports__